import React from "react";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { Link } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import { useSelector } from "react-redux";

const Error500 = () => {
  const translation = useSelector(state => state.root.translation);
  const route = all_routes;
  return (
    <div className="main-wrapper">
      <div className="error-box">
        <div className="error-img">
          <ImageWithBasePath
            src="assets/img/authentication/error-500.png"
            className="img-fluid"
            alt="img"
          />
        </div>
        <h3 className="h2 mb-3">{translation["oops,_something_went_wrong"]}</h3>
        <p>
          {translation["server_error_500_we_apologise_and_are_fixing_the_problem_please_try_again_at_a_later_stage"]}
        </p>
        <Link to={route.dashboard} className="btn btn-primary">
          Back to Dashboard
        </Link>
      </div>
    </div>
  );
};

export default Error500;
